import { AxiosPromise }                from 'axios';
import { client }                      from '@/service/client';
import { CalendarConfigurationConfig } from '@/views/calendar-configuration/calendar-configuration.types';

export function getCalendarConfiguration(): AxiosPromise {
  return client.get('/dashboard/calendar-configuration');
}

export function putCalendarConfiguration(calendarConfiguration: CalendarConfigurationConfig): AxiosPromise {
  return client.put('/dashboard/calendar-configuration', calendarConfiguration);
}
